import { useConfig, useCustomerActionConfig, usePortal, } from "@/contexts/cdpConfig";
import { useAdsContext } from "@/ads/context";
import { useClassified } from "@/contexts/classified";
import { useState, useRef, useEffect } from "react";
import { useTokens } from "@gemini/core";
import { IS_SERVER } from "@/constants";
export function useCustomDataCollector() {
    var _a, _b;
    const [data, setData] = useState(null);
    const tokens = useTokens();
    const config = useConfig();
    const tokenString = (_a = config.customerActionSecrets) !== null && _a !== void 0 ? _a : "";
    const portal = usePortal();
    const customerActionEnabled = useCustomerActionConfig();
    const { targeting } = useAdsContext();
    const processedActions = useRef(new Set());
    const legacyId = (_b = useClassified()) === null || _b === void 0 ? void 0 : _b.metadata.legacyId;
    const isDesktop = IS_SERVER
        ? undefined
        : window.matchMedia(`(min-width: ${tokens["breakpoint.lg"] || 1024}px)`)
            .matches;
    useEffect(() => {
        setData({
            config: config,
            tokenString: tokenString,
            portal: portal,
            customerActionEnabled: customerActionEnabled,
            targetingVars: targeting,
            processedActions: processedActions,
            legacyId: legacyId,
            isDesktop: isDesktop,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            isCypress: typeof window.Cypress !== "undefined",
        });
    }, [
        isDesktop,
        config,
        tokenString,
        portal,
        customerActionEnabled,
        targeting,
        processedActions,
        legacyId,
    ]);
    return data;
}
